import React from "react";
import { Link, useLocation } from "react-router-dom";
import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import SearchBar from "./SearchBar";
import "../css/OnBoardMenu.css"; // Assuming this contains styles for .onboard-menu-item if needed
import NavigationDropdown from "./Dropdowns/NavigationDropdown";
import AddRecruitButton from "./Buttons/AddRecruitButton";
import UserProfileSection from "./UserProfileSection";
import StructureButton from "./Buttons/StructureRedirectButton";
import ColumnVisibilityButton from "./Buttons/ColumnVisibilityButton";
import { SumisniIcon } from "../icons/SumisniIcon";

const OnBoardMenu = ({
  handleSearch,
  columnVisibility,
  setColumnVisibility,
  defaultVisibility,
  columnMeta,
}) => {
  const location = useLocation();

  return (
    <NavigationMenu.Root
      id="navbar"
      className="pb-5 pt-10"
      orientation="horizontal"
    >
      <NavigationMenu.List className="flex items-center justify-between h-full">
        {/* Left Section */}
        <div className="ml-10 gap-x-6">
          {/* Group 1: Logo + Structure/Visibility Buttons */}
          <div className="flex items-center gap-x-6">
            <NavigationMenu.Item>
              <NavigationMenu.Link asChild>
                <Link to="/">
                  <SumisniIcon />
                </Link>
              </NavigationMenu.Link>
            </NavigationMenu.Item>

            <div className="flex items-center gap-x-2.5">
              {/* Original gap-2.5 */}
              <NavigationMenu.Item className="flex items-center">
                <StructureButton />
              </NavigationMenu.Item>
              {location.pathname !== "/structure" && (
                <NavigationMenu.Item className="flex items-center">
                  <ColumnVisibilityButton
                    columnVisibility={columnVisibility}
                    setColumnVisibility={setColumnVisibility}
                    defaultVisibility={defaultVisibility}
                    columnMeta={columnMeta}
                  />
                </NavigationMenu.Item>
              )}
              {location.pathname !== "/analytics" && (
                <NavigationMenu.Item>
                  <AddRecruitButton />
                </NavigationMenu.Item>
              )}
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="bg-white flex items-center p-2.5 rounded-[100px]">
          <NavigationMenu.Item>
            <SearchBar onSearch={handleSearch} />
          </NavigationMenu.Item>
          <NavigationMenu.Item>
            <NavigationDropdown />
          </NavigationMenu.Item>
          <NavigationMenu.Item>
            <UserProfileSection />
          </NavigationMenu.Item>
        </div>
      </NavigationMenu.List>
    </NavigationMenu.Root>
  );
};

export default OnBoardMenu;
